import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const resendVideoLink = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.VIDEO.RESEND_VIDEO_LINK,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
